const Url = {
   baseApiUrl : process.env.REACT_APP_LAMBDA_URL,
  //  baseApiUrl:
  //    "https://173riv98n3.execute-api.ap-south-1.amazonaws.com/testing/v1",
  adminBaseUrl: process.env.REACT_APP_ADMIN_LAMBDA_URL,
  //   adminBaseUrl : "https://w72a5si42a.execute-api.ap-south-1.amazonaws.com/dev/v1";
  // adminBaseUrl : "https://dssqy2gip2.execute-api.ap-south-1.amazonaws.com/testing/v1",

  // baseApiUrl : "https://3tplueug92.execute-api.ap-south-1.amazonaws.com/dev/v1";
    // baseApiUrl: "http://localhost:3002/v1"
};

const apiRoutes = {
  userLogin: "/login",
  loginWithOTP: "/loginWithOTP",
  validateOTP: "/validateOTP",
  logout: "/logout",
  fetchTeacherClasses: "/fetchTeacherClasses",  
  fetchTeacherSectionsBasedonClass: "/fetchTeacherSectionsBasedonClass",
  fetchTeacherSubjectsBasedonSection: "/fetchTeacherSubjectsBasedonSection",
}

export { Url, apiRoutes };